import { render, staticRenderFns } from "./TechServiceOwnerForm.vue?vue&type=template&id=16479f75"
import script from "./TechServiceOwnerForm.vue?vue&type=script&lang=js"
export * from "./TechServiceOwnerForm.vue?vue&type=script&lang=js"
import style0 from "./TechServiceOwnerForm.vue?vue&type=style&index=0&id=16479f75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports